.learningCentreTitle {
  display: flex;
  flex-direction: row;
  margin-bottom: 2.4rem;
  font-weight: bold;
  font-size: 1.6rem;
  line-height: 1.2;
}

.learningCentreContentRow {
  gap: 7rem;
}

.column {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.row {
  display: flex;
  flex-direction: row;
}

.marginBottomMd {
  margin-bottom: 1.6rem;
}

.dashedLine {
  margin: 1.4rem 0 1rem 0;
  border-top: 0.1rem dashed rgba(var(--color-regent-gray-rgb), 0.55);
}

.circleIcon {
  transform: rotate(-180deg);
}

.blueIcon {
  color: var(--color-shadow-green);
}

.learningCentreIcon {
  margin-right: 2rem;
}
.bold {
  font-weight: bold;
}
